export const selectAuth = ({auth} = {}) => auth;
export const getAuthProfile = ({auth: {authProfile} = {}} = {}) => authProfile;
export const getSecondData = ({auth: {secondData} = {}} = {}) => secondData;
export const getStartUrl = ({auth: {startUrl} = {}} = {}) => startUrl;
export const getAuthStatus = ({auth: {authStatus} = {}} = {}) => authStatus;
export const selectSessionId = ({auth: {sessionId} = {}} = {}) => sessionId;
